<template>
	<div class="main" v-loading="list_loading">
		<mybread></mybread>
		<div class="searchConent">
			<el-row>
				<el-col :span="3">设备编号：</el-col>
				<el-col :span="9"><el-input v-model="deviceNu" placeholder="请输入"></el-input></el-col>
				<el-col :span="3">设备名称：</el-col>
				<el-col :span="9"><el-input v-model="deviceNa" placeholder="请输入"></el-input></el-col>
			</el-row>
			<el-row>
				<el-col :span="3">设备类型：</el-col>
				<el-col :span="9">
					<el-select v-model="deviceId" placeholder="请选择">
						<el-option v-for="item in deviceData" :key="item.deviceId" :label="item.name" :value="item.deviceId"></el-option>
					</el-select>
				</el-col>
				<el-col :span="3">来源采集方式：</el-col>
				<el-col :span="9">
					<el-select v-model="collectId" placeholder="请选择">
						<el-option v-for="item in collectData" :key="item.collectId" :label="item.name" :value="item.collectId"></el-option>
					</el-select>
				</el-col>
			</el-row>
			<p class="search"><el-button @click="searchClick" type="primary" icon="el-icon-search">查询</el-button></p>
		</div>
		<el-table :data="monitorList" border style="width: 100%">
			<el-table-column prop="deviceNo" label="设备编号" width="180"></el-table-column>
			<el-table-column prop="deviceName" label="设备名称" width="180"></el-table-column>
			<el-table-column prop="deviceType" label="设备类型"></el-table-column>
			<el-table-column prop="collectType" label="来源采集方式"></el-table-column>
			<el-table-column prop="collectSys" label="来源采集平台"></el-table-column>
			<el-table-column prop="body" label="设备监测数据"></el-table-column>
			<el-table-column prop="result" label="结果"></el-table-column>
			<el-table-column prop="gatewayNo" label="网关编号"></el-table-column>
			<el-table-column prop="createTime" label="时间"></el-table-column>
		</el-table>
		<div class="block">
			<el-pagination
				@current-change="handleCurrentChange"
				:current-page="currentPage"
				background
				@size-change="handleSizeChange"
				:page-sizes="[5, 10, 20]"
				:page-size="pageSize"
				layout="sizes, prev,pager, next,total,jumper"
				:total="total"
			></el-pagination>
		</div>
	</div>
</template>

<script>
import mybread from '@/components/bread';
export default {
	components: {
		mybread
	},
	data() {
		return {
			deviceNu:"",
			deviceNa:"",
			deviceData:[{
				deviceId:1,
				name:"烟感设备"
			},{
				deviceId:2,
				name:"紧急按钮设备"
			},{
				deviceId:3,
				name:"水浸设备"
			},{
				deviceId:4,
				name:"人体活动智能检测终端"
			},{
				deviceId:5,
				name:"温湿度智能检测终端"
			},{
				deviceId:6,
				name:"温感智能检测终端"
			},{
				deviceId:7,
				name:"门磁智能检测终端"
			},{
				deviceId:8,
				name:"人体感应夜灯"
			}],
			deviceId:"",
			collectData:[{
				collectId:1,
				name:"APP"
			},{
				collectId:2,
				name:"微信"
			},{
				collectId:3,
				name:"会员网站端"
			}],
			// collectData:["APP","微信","会员网站端"],
			collectId:"",
			monitorList: [],
			total: 0, //总页数
			pageSize: 10, //每页条数
			currentPage: 1, //当前页（默认第一页）
			list_loading: true,
			
		};
	},
	created() {
		this.getMonitor();
	},
	methods: {
		searchClick(){
			this.getMonitor();
		},
		handleCurrentChange(val) {
			this.currentPage = val; //获取当前页
			this.getMonitor();
		},
		handleSizeChange(psize) {
			//选择每页条数
			this.pageSize = psize;
			this.getMonitor();
		},
		getMonitor() {
			let data = new FormData();
			data.append('length',this.pageSize);
			data.append('start',(this.currentPage - 1) * this.pageSize);
			data.append('deviceNo',this.deviceNu);
			data.append('deviceName',this.deviceNa);
			data.append('deviceType',this.deviceId);
			data.append('collectType',this.collectId);
			this.$post('api/deviceData/list',data)
				.then(res => {
					this.monitorList = res.data;
					this.total = res.recordsFiltered;
					this.list_loading = false;
					this.monitorList.map(function(val) {
						switch (val.collectType) {
							case 1:
								val.collectType = 'APP';
								break;
							case 2:
								val.collectType = '微信';
								break;
							default:
								val.collectType = '会员网站端';
								break;
						}
						switch (val.deviceType) {
							case 1:
								val.deviceType = '烟感设备';
								break;
							case 2:
								val.deviceType = '紧急按钮设备';
								break;
							case 3:
								val.deviceType = '水浸设备';
								break;
							case 4:
								val.deviceType = '人体活动智能检测终端';
								break;
							case 5:
								val.deviceType = '温湿度智能检测终端';
								break;
							case 6:
								val.deviceType = '温感智能检测终端';
								break;
							case 7:
								val.deviceType = '门磁智能检测终端';
								break;
							default:
								val.deviceType = '人体感应夜灯';
								break;
						}
					});
				})
				.catch(e => {
					window.console.log(e);
				});
		}
	}
};
</script>

<style>
.block {
	text-align: center;
	margin-top: 20px;
}
.searchConent .el-row .el-col:first-of-type {
	border-right: 1px solid #eee;
}
.searchConent .el-row:first-of-type {
	display: flex;
	border: 1px solid #eee;
}
.searchConent .el-row:nth-of-type(2) {
	border-left: 1px solid #eee;
	border-bottom: 1px solid #eee;
	border-right: 1px solid #eee;
}
.searchConent .el-col:nth-of-type(3) {
	border-left: 1px solid #eee;
	border-right: 1px solid #eee;
}
.searchConent .el-col {
	height: 50px;
	padding: 5px;
	line-height: 38px !important;
	color: #606266;
	font-size: 14px;
}
.searchConent .el-col:first-of-type,
.searchConent .el-col:nth-of-type(3) {
	text-align: center;
}
.searchConent{
	margin-bottom: 20px;
}
.searchConent .search{
	text-align: right;
	margin-top: 20px;
}
.main {
	background: #fff;
	padding: 0 20px 20px 20px;
}
.el-table td,
.el-table th {
	text-align: center;
}
.searchConent .el-select {
	width: 100%;
}
</style>
